import { NoSymbolIcon } from "@heroicons/react/20/solid";
import React from "react";
import { connect } from 'react-redux';
import { Actions as ADVISORACTIONS } from '../../../store/actions/advisorActions';

const MemberRow = ({
    member,
    canDeleteOthers,
    removeTeamMember,
    advisorId,
}) => {
    return (
        <tr>
            <td>
                {member.name || "User Not Found"}
            </td>
            <td>
                {member.status}
                {canDeleteOthers &&
                <div
                    className="btn btn-xs btn-danger pull-right"
                    type="button"
                    title={`Remove ${member.name || "user"} from advisor team`}
                    onClick={() => {
                        removeTeamMember({ member, advisorId });
                    }}
                    style={{ marginRight: 10 }}
                >
                    <NoSymbolIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                </div>}
            </td>
        </tr>
    )
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => ({
    removeTeamMember: ({ member, advisorId }) => dispatch(ADVISORACTIONS.removeTeamMember({ member, advisorId })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MemberRow)